const { Core, Utils, Events } = Global;
const { $fetch, parseHTML } = Utils;


customElements.define('cart-provider', class extends Core {
    liveSections = new Set();
    notificationsEnabled = false;
    pendingGifts = new Set();
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    render() {
        this.sub(Events.CART_REGISTER, this._registerSection, { global: true });
        this.sub(Events.CART_NOTIFICATIONS_ENABLING, this._enableNotifications, { global: true });
        this.sub(Events.CART_ADD, this._addToCart, { global: true });
        this.sub(Events.CART_CHANGE, this._updateCart, { global: true });
        this.sub(Events.CART_REPLACE, this._replaceCartItem, { global: true });
        this.sub(Events.PRODUCT_FORM_SUBMIT, this._formSubmitHandler, { global: true });

        this._setExternalAPI();
        document.addEventListener('cart:items-added', async (e) => {
            const cart = e.detail.cart;
            console.log('Received cart:items-added event, running free gift logic...');
            
            // OPTIMIZATION: Run free gifts logic first, then sync static product
            // These need to run sequentially because they modify the cart
            // But we don't block the UI - this runs in background
            await this._handleFreeGifts(cart);
            await this._syncStaticProduct();
            
            // Fetch sections and update UI in background
            // User already sees cart drawer, so this is just updating with final data
            const sectionRes = await fetch(`${window.dynamicURLs['root']}?sections=${Array.from(this.liveSections).join(',')}`);
            const sections = await sectionRes.json();
            this.pub(Events.CART_UPDATE, {
                sections,
                req: 'freeGifts'
            });
        });
    }

    _registerSection(section) {
        this.liveSections.add(section);
    }

    _enableNotifications() {
        this.notificationsEnabled = true;
    }

   async _formSubmitHandler({ formData }) {
    this.notificationsEnabled && formData.append("attributes[notification_items_variant_ids]", formData.get('id'));
    formData.append("sections", Array.from(this.liveSections).join(','));

    const config = {
        method: 'POST',
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Accept": "application/javascript"
        },
        body: formData
    }
    
    try {
        const res = await fetch(`${window.dynamicURLs['cartAdd']}.js`, config);
        
        const cartData = await res.json();

        if(!res.ok) {
            this.pub(Events.TOAST_NOTIFICATION, {
                type: 'error',
                msg: cartData.description,
                title: cartData.message
            });
            throw new Error(cartData.description);
        }
        const cart = await fetch('/cart.js').then(r => r.json());
        await this._handleFreeGifts(cart);

        await this._syncStaticProduct();

        const sectionRes = await fetch(`${window.dynamicURLs['root']}?sections=${Array.from(this.liveSections).join(',')}`);
        const sections = await sectionRes.json();

        this.pub(Events.CART_UPDATE, {
            sections,
            req: "cartAdd"
        })

    } catch (error) {
        console.error(error);
        this.pub(Events.CART_ERROR, error);
    } finally {
        this.notificationsEnabled && this._cleanCartAttributes();
    }
}

    
    async _addToCart({ items }) {
        
        await this._requestCart('cartAdd', {
            items,
            ...(this.notificationsEnabled && { attributes: {
                notification_items_variant_ids: items.map(({id}) => id).join(',')
            }})
        }, items.map(item => item.id));
        this._cleanCartAttributes();
       
    }

    _cleanCartAttributes() {
        this._fetchCart('cartUpdate', { attributes: { notification_items_variant_ids: null }});
    }

    _fetchCart(route, body) {
        return fetch(`${window.dynamicURLs[route]}.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(
                body
            )
        })
        
    }

    async _updateCart({ quantity, line }) {
        // NOTE: Terrible, but forced to use line (index) because of unexpected shopify cart API behavior.    
        // TODO: Deprecate line usage    
        await this._requestCart('cartChange', {
            line,
            quantity
        });
    }

    async _replaceCartItem({line, newItem, quantity}) {
        await this._fetchCart('cartChange', {
            line, quantity: 0
        });
        this._addToCart({items: [{ id: newItem, quantity }]});
    }

  /// Custom Function check to add & remove Quantity of Warranty/Subscription Product
     async _syncStaticProduct() {
        // Get subscription product details - use global fallback if not set on current page
        const staticVariantId = window.wproduct?.variant || 31356926853154;
        const sellingPlanId = window.wproduct?.meta?.selling_plan_id || '689283760429';

        if (!staticVariantId) {
            console.warn("🚫 Static product variant ID missing.");
            return;
        }

        try {
            const res = await fetch('/cart.js');
            if (!res.ok) {
                console.warn("⚠️ Failed to fetch /cart.js");
                return;
            }

            const cart = await res.json();
            const items = cart.items || [];

            const hasStatic = items.some(item => item.variant_id === staticVariantId);
            const staticItemIndex = items.findIndex(item => item.variant_id === staticVariantId);
            const staticItem = staticItemIndex !== -1 ? items[staticItemIndex] : null;
            const itemsExceptStatic = items.filter(item => item.variant_id !== staticVariantId);

            // Cart has other items and static not in cart → Add static
            if (itemsExceptStatic.length > 0 && !hasStatic) {
                const addResponse = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: staticVariantId,
                        quantity: 1,
                        ...(sellingPlanId && { selling_plan: sellingPlanId })
                    })
                });

                if (!addResponse.ok) {
                    const errorText = await addResponse.text();
                } else {
                    document.dispatchEvent(new Event('cart:refresh'));
                }
            }

            // Cart has static, but quantity is not 1 → Fix it
            if (hasStatic && staticItem?.quantity !== 1) {
                const line = staticItemIndex + 1;
                console.log("Adjusting static product quantity to 1...");

                const changeRes = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ line, quantity: 1 })
                });

                if (!changeRes.ok) {
                    const errText = await changeRes.text();
                    console.error("Failed to update static quantity:", errText);
                } else {
                    console.log("Static product quantity reset to 1.");
                    document.dispatchEvent(new Event('cart:refresh'));
                }
            }

            // Cart has only static product → Remove it
            if (itemsExceptStatic.length === 0 && hasStatic) {
                const line = staticItemIndex + 1;
                console.log("Removing static product (cart is otherwise empty)...");

                const removeRes = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ line, quantity: 0 })
                });

                if (!removeRes.ok) {
                    const errText = await removeRes.text();
                } else {
                    document.dispatchEvent(new Event('cart:refresh'));
                }
            }

        } catch (error) {
            console.error('Error in _syncStaticProduct():', error);
        }
    }


    // End

  
    // async _requestCart(route, body) {
    //     try {
    //         const res = await this._fetchCart(route, {
    //             ...body,
    //             sections: Array.from(this.liveSections).join(','),
    //         });
            
    //         const cartData = await res.json();

    //         if(!res.ok) {
    //             this.pub(Events.TOAST_NOTIFICATION, {
    //                 type: 'error',
    //                 msg: cartData.description,
    //                 title: cartData.message
    //             });
    //             throw new Error(cartData.description);
    //         }  
    //         await this._syncStaticProduct();

    //         this.pub(Events.CART_UPDATE, {
    //             sections: cartData.sections,
    //             req: route
    //         })
          
           
          
    //     } catch (error) {
    //         console.error(error);
    //         this.pub(Events.CART_ERROR, error);
    //     }
    // }

    
       async _handleFreeGifts(cart) {

    /* ----------------------------------------
    ✅ CONFIG
    ----------------------------------------- */

    // 🛒 Quantity-based gifts
    const quantityGifts = [
        { units: 2, variantId: 40525786120226, title: "Free Basic Mystery Loot" },
        { units: 3, variantId: 51326828937517, title: "Free Launcher" }
    ];

    // 💰 Cart total-based gifts
    const freeProducts = [
        { threshold: 3499, variantId: 51793315823917, title: "Free 4 Pack Metals" },
        { threshold: 4999, variantId: 51793319526701, title: "Premium Mystery Gift" },
        { threshold: 8000, variantId: 52068017668397, title: "Free 20 Random Burst" },
        { threshold: 10000, variantId: 51793319231789, title: "Mystery Loot Box" }
    ];

    /* ----------------------------------------
    EXCLUDE PRODUCTS
    ----------------------------------------- */

    const excludedProductIds = [
        51649031536941,
        51649021509933,
        51649032618285,
        51649115455789,
        51649029407021,
        51649113784621,
        51649084555565,
        51945204973869,
        40525786120226,
        51326828937517,
        51793315823917,
        51793319526701,
        51793319231789,
        51543130439981,
        31356926853154,
        50877988503853,50877982114093,51648995852589,50877986308397,50877981491501,51649183154477,51649108705581,
        51649002930477,50877988405549,51649014137133,51648999850285,50877983195437,50877983752493,51649019543853,
        51502873018669,52017997185325,51649086423341,52017980342573,51649001980205,51958345597229,52018075435309,50877983490349,50877982048557,
        51987507249453,52068017668397
    ];

    /* ----------------------------------------
    CALCULATIONS
    ----------------------------------------- */

    const adjustedTotal = cart.items.reduce((total, item) => {
        if (excludedProductIds.includes(item.variant_id)) return total;
        return total + item.line_price;
    }, 0);

    const cartQuantity = cart.items.reduce((total, item) => {
        if (excludedProductIds.includes(item.variant_id)) return total;
        return total + item.quantity;
    }, 0);

    /* ----------------------------------------
    🛒 QUANTITY LOGIC
    ----------------------------------------- */

    for (const gift of quantityGifts) {

        const qualifies = cartQuantity >= gift.units;
        const variantId = gift.variantId;

        if (this.pendingGifts.has(variantId)) continue;

        let cartItem = cart.items.find(item => item.variant_id === variantId);

        if (qualifies) {
            if (!cartItem) {
                this.pendingGifts.add(variantId);

                try {
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: variantId, quantity: 1 })
                    });
                } finally {
                    this.pendingGifts.delete(variantId);
                }
            }
        } else if (cartItem) {
            const line = cart.items.findIndex(item => item.variant_id === variantId) + 1;

            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line, quantity: 0 })
            });
        }
    }

    /* ----------------------------------------
    💰 CART TOTAL LOGIC (YOUR ORIGINAL)
    ----------------------------------------- */

    const groupedVariants = {};
    for (const { threshold, variantId } of freeProducts) {
        if (!groupedVariants[variantId]) groupedVariants[variantId] = [];
        groupedVariants[variantId].push(threshold);
    }

    for (const [variantIdStr, thresholds] of Object.entries(groupedVariants)) {
        const variantId = Number(variantIdStr);
        const qualifies = thresholds.some(t => adjustedTotal >= t);

        if (this.pendingGifts.has(variantId)) continue;

        let cartItem = cart.items.find(item => item.variant_id === variantId);

        if (qualifies) {
            if (!cartItem) {
                this.pendingGifts.add(variantId);

                try {
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: variantId, quantity: 1 })
                    });
                } finally {
                    this.pendingGifts.delete(variantId);
                }
            }
        } else if (cartItem) {
            const line = cart.items.findIndex(item => item.variant_id === variantId) + 1;

            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line, quantity: 0 })
            });
        }
    }

    /* ----------------------------------------
    🎯 MESSAGE LOGIC (UPDATED FOR BOTH)
    ----------------------------------------- */

    const messageContainer = document.querySelector('#free-gift-message');

    const nextQuantity = quantityGifts.find(g => cartQuantity < g.units);
    const nextPrice = freeProducts.find(p => adjustedTotal < p.threshold);

    if (messageContainer) {
        if (nextQuantity) {
            messageContainer.innerHTML = `Add ${nextQuantity.units - cartQuantity} more item(s) to get ${nextQuantity.title}`;
        } else if (nextPrice) {
            const remaining = (nextPrice.threshold - adjustedTotal) / 100;
            messageContainer.innerHTML = `Spend $${remaining.toFixed(2)} more to get ${nextPrice.title}`;
        } else {
            messageContainer.innerHTML = `🎉 You’ve unlocked all rewards!`;
        }
    }

    /* ----------------------------------------
    🚚 SHIPPING LOGIC (UPDATED)
    ----------------------------------------- */

    const shippingContainer = document.querySelector("#free-shipping-message");

    if (shippingContainer) {

        const cartTotal = cart.total_price;

        if (cartTotal >= 10000) {
            shippingContainer.innerHTML = `⚡ Free Priority Shipping Unlocked`;
        } else if (cartTotal >= 6499) {
            const remaining = ((10000 - cartTotal) / 100).toFixed(2);
            shippingContainer.innerHTML = `
                🚚 Free Shipping Unlocked<br>
                ⚡ $${remaining} away from Priority Shipping
            `;
        } else {
            const remaining = ((6500 - cartTotal) / 100).toFixed(2);
            shippingContainer.innerHTML = `
                🚚 Spend $${remaining} more for Free Shipping
            `;
        }
    }

    //renderGiftProgressBar(adjustedTotal, freeProducts);
    renderGiftProgressBar(adjustedTotal, freeProducts, cartQuantity, quantityGifts);
}



    
    async _requestCart(route, body) {
    try {
        const res = await this._fetchCart(route, {
        ...body,
        sections: Array.from(this.liveSections).join(',')
        });
        const cartData = await res.json();

        if (!res.ok) {
        this.pub(Events.TOAST_NOTIFICATION, {
            type: 'error',
            msg: cartData.description,
            title: cartData.message
        });
        throw new Error(cartData.description);
        }

        // OPTIMIZATION: Fetch cart once and use it for both operations
        // This saves one network request compared to fetching separately
        const cart = await fetch('/cart.js').then(r => r.json());
        
        // Run free gifts and static product sync sequentially
        // They need to run in order because they modify the cart
        await this._handleFreeGifts(cart);   
        await this._syncStaticProduct();
        
        // After adjustments, fetch sections and update UI
        const sectionRes = await fetch(`${window.dynamicURLs['root']}?sections=${Array.from(this.liveSections).join(',')}`);
        const sections = await sectionRes.json();
        this.pub(Events.CART_UPDATE, {
            sections,
            req: route 
        });

    } catch (error) {
        console.error('Error in _requestCart with free gift logic:', error);
        this.pub(Events.CART_ERROR, error);
    }
    }

    _setExternalAPI() {
        document.addEventListener('cart:refresh', this._cartRefresh.bind(this));
    }

    async _cartRefresh() {
        const cartSectionsReqURL = `${window.dynamicURLs['root']}?sections=${Array.from(this.liveSections).join(',')}`;

        try {
            const data = await fetch(cartSectionsReqURL);
            const sections = await data.json();

            this.pub(Events.CART_UPDATE, {
                sections
            });         
          // Also re-sync static product when cart refresh happens
          //await this._syncStaticProduct();
          
          
        } catch (err) {
            console.error(err);
        }
        
    }
})

customElements.define('cart-qty', class extends Core {
    propTypes = {
        value: Number,
        key: String,
        input: Boolean,
        'prevent-default': Boolean,
        line: Number
    }

    render() {
        this.$({
            [this.evt]: this._handleEvent
        })
    }

    _handleEvent(e) {
        this.prop('prevent-default') && e.preventDefault();
        this.pub(Events.CART_CHANGE, {
            key: this.prop('key'),
            line: this.prop('line'),
            quantity: this._getValue(e)
        })
    }

    _getValue(e) {
        return this.evt === 'change'
            ? this._getValidatedValue(e)
            : this.prop('value'); 
    }

    _getValidatedValue(e) {
        const maxValue = e.target.hasAttribute('max') && +e.target.getAttribute('max');
        if (maxValue && e.target.value > maxValue) {
            e.target.value = maxValue
            return maxValue
        }
        return e.target.value
    }

    get evt() {
        return this.prop('input') 
            ? 'change' 
            : 'click';
    }
});

customElements.define('cart-live-region', class extends Core {
    propTypes = {
        'target-section': String,
        'target-element': String
    }

    render() {
        this.targetSection = this.prop('target-section') || this.sectionId;
        this.targetSelector = this.prop('target-element') || `#${this.id}`;

        customElements.whenDefined('cart-provider').then(() => {
            this.pub(Events.CART_REGISTER, this.targetSection)
        })

        this.sub(Events.CART_UPDATE, this._updateContent, { global: true })
    }
    
    _updateContent({ sections }) {
        const targetSection = sections && sections[this.targetSection];
        if(!targetSection) {
            console.error(`target section ${targetSection} do not exists`);
            return;
        }
        const doc = Utils.parseHTML(targetSection);
        Utils.$replaceContent(this, doc.querySelector(this.targetSelector));

        
    }

})

function renderGiftProgressBar(currentTotal, freeProducts, cartQuantity = 0, quantityGifts = []) {

    const container = document.querySelector('#gift-progress-container');
    if (!container) return;

    /* ----------------------------------------
    🧠 MERGE BOTH TIERS INTO ONE TIMELINE
    ----------------------------------------- */

    const steps = [
        ...quantityGifts.map(g => ({
            type: "quantity",
            value: g.units,
            title: g.title
        })),
        ...freeProducts.map(p => ({
            type: "price",
            value: p.threshold,
            title: p.title
        }))
    ];

    // Sort: quantity first → then price
    steps.sort((a, b) => {
        if (a.type === b.type) return a.value - b.value;
        return a.type === "quantity" ? -1 : 1;
    });

    const totalSteps = steps.length;

    /* ----------------------------------------
    🎯 FIND PROGRESS
    ----------------------------------------- */

    let reachedIndex = -1;

    steps.forEach((step, index) => {
        if (
            (step.type === "quantity" && cartQuantity >= step.value) ||
            (step.type === "price" && currentTotal >= step.value)
        ) {
            reachedIndex = index;
        }
    });

    const progressPercent = totalSteps > 1
        ? (reachedIndex / (totalSteps - 1)) * 100
        : 0;

    /* ----------------------------------------
    🎨 RENDER
    ----------------------------------------- */

    container.innerHTML = `
        <div class="gift-progress-bar-wrapper">
            <div class="gift-progress-bar-bg">
                <div class="gift-progress-bar-fill" style="width: ${progressPercent}%;"></div>
            </div>
            <div class="gift-progress-markers">
                ${steps.map((step, index) => {

                    const leftPercent = totalSteps > 1
                        ? (index / (totalSteps - 1)) * 100
                        : 0;

                    const reached =
                        (step.type === "quantity" && cartQuantity >= step.value) ||
                        (step.type === "price" && currentTotal >= step.value);

                    return `
                        <div class="gift-marker ${reached ? 'reached' : ''}" style="left: ${leftPercent}%; top: 0;">
                            <div class="gift-icon">
                                <div class="gift_icon">
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAk0lEQVR4nO3PMQrCQBRF0Q82EZcQLMQNWtkJWrgfERQLd2MlpE95JDiICELIBJGQCwPzecO/byL+DexR4YYdJjnLSpxR44pVmst0jtjmCE5YY4qNJ4u3fI57jqDGLN2LZvtH3giqHMEhNS/S/BJgiUvzw7bLeiO+CdqUiK5vhiHoi+jaUGY+CmIUxCiInwhyicHxAP4T9IRxken4AAAAAElFTkSuQmCC" alt="gift">
                                </div>
                            </div>
                            <div class="gift-title">
                                ${step.type === "quantity" 
                                    ? `${step.value} items` 
                                    : `$${(step.value / 100).toFixed(0)}`
                                }
                                <br>${step.title}
                            </div>
                        </div>
                    `;
                }).join('')}
            </div>
        </div>
    `;
}